// useLikes.ts
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "./queryKeys";
import LikeService from "@/integrations/service/like.service";
import { getVisitorId } from "@/lib/visitorId";

export const useLikeStatut = (articleId?: number) => {
  return useQuery({
    queryKey: queryKeys.likes(articleId ?? 0),
    queryFn: () => LikeService.statut(articleId as number, getVisitorId()),
    enabled: !!articleId,
  });
};

/** Admin/lecture seule : uniquement le total, sans statut "liké par moi". */
export const useLikeCount = (articleId?: number) => useLikeStatut(articleId);

export const useToggleLike = (articleId?: number) => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: () => LikeService.basculer(articleId as number, getVisitorId()),
    onSuccess: (data) => {
      if (articleId) qc.setQueryData(queryKeys.likes(articleId), data);
    },
  });
};
